import { CalendarViewEnum } from "pages/agenda/Agenda.types";
import {
  ActivityFilterEnum,
  AGENDA_LOCAL_STORAGE_KEY,
} from "./AgendaFilters.constants";

export const getFiltersOptions = (t: any) => {
  const filters: string[] = Object.values(ActivityFilterEnum);
  return filters.map((filter) => ({
    value: filter,
    label: t(`agendaFilters.${filter}`),
  }));
};

export const getAgendaLocalStorage = () => {
  return JSON.parse(localStorage.getItem(AGENDA_LOCAL_STORAGE_KEY) || "{}");
};

export const updateAgendaStorage = (
  newData: Partial<{
    selectedActivitiesIds: string[];
    selectedMembers: string[];
    selectedFilter: string;
    selectedDate: string;
    selectedView: CalendarViewEnum;
  }>,
) => {
  const current = getAgendaLocalStorage();
  const updated = { ...current, ...newData };
  localStorage.setItem(AGENDA_LOCAL_STORAGE_KEY, JSON.stringify(updated));
};
